export default "__VITE_ASSET__DVCHqLKJ__"